/**
 * The net/total readout for the current selection.
 *
 * Kept out of the floating selection bar deliberately: that dock is an action
 * toolbar, and amounts can span currencies, which makes for a string long
 * enough to crowd the buttons or wrap the dock onto a second line. This sits
 * in the page flow instead, in the same slot the active-filter chips use, so
 * it never competes with the actions for width.
 *
 * Renders nothing without a selection, so the panel keeps its height at rest.
 */
export function InvoiceSelectionSummary({ count = 0, netTotal = null, grossTotal = null }) {
  if (count === 0 || (!netTotal && !grossTotal)) return null;

  return (
    <div className="selection-summary-bar" role="status" aria-live="polite">
      <span className="selection-summary-count">
        <span className="num">{count}</span> selected
      </span>
      {netTotal && (
        <span className="selection-summary-figure">
          Net <span className="num">{netTotal}</span>
        </span>
      )}
      {grossTotal && (
        <span className="selection-summary-figure">
          Total <span className="num">{grossTotal}</span>
        </span>
      )}
    </div>
  );
}
